import dataBloedErnstigLMWH from "../../../../src/data/ernstige-bloedingen-onder-lmwh-ongefractioneerde-heparine.json";
import BasicSchematic from "../../../../src/components/chart/interaction/basic-schematic/Chart.js";
import * as React from 'react';
export default {
  dataBloedErnstigLMWH,
  BasicSchematic,
  React
};